import { render, staticRenderFns } from "./icon-message.vue?vue&type=template&id=01c1ca52&scoped=true"
import script from "./icon-message.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-message.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./icon-message.vue?vue&type=style&index=0&id=01c1ca52&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c1ca52",
  null
  
)

export default component.exports